import { render, staticRenderFns } from "./GeomagneticHistoricalDetail.vue?vue&type=template&id=135278e8&scoped=true"
import script from "./GeomagneticHistoricalDetail.vue?vue&type=script&lang=js"
export * from "./GeomagneticHistoricalDetail.vue?vue&type=script&lang=js"
import style0 from "./GeomagneticHistoricalDetail.vue?vue&type=style&index=0&id=135278e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135278e8",
  null
  
)

export default component.exports